import { DayOfWeek } from '@wix/ambassador-forms-v4-form/types';
import type {
  Availability,
  DateRange,
} from '@wix/ambassador-forms-v4-form/types';

import { startOfDay } from '../../../date-localization/local-date';

export const ALL_DAYS: DayOfWeek[] = [
  DayOfWeek.SUNDAY,
  DayOfWeek.MONDAY,
  DayOfWeek.TUESDAY,
  DayOfWeek.WEDNESDAY,
  DayOfWeek.THURSDAY,
  DayOfWeek.FRIDAY,
  DayOfWeek.SATURDAY,
];

export const DEFAULT_AVAILABILITY: Availability & {
  availableDays: DayOfWeek[];
} = {
  availableDays: ALL_DAYS,
};

const NUMERIC_DAY_TO_STRING: Record<number, DayOfWeek> = {
  0: DayOfWeek.SUNDAY,
  1: DayOfWeek.MONDAY,
  2: DayOfWeek.TUESDAY,
  3: DayOfWeek.WEDNESDAY,
  4: DayOfWeek.THURSDAY,
  5: DayOfWeek.FRIDAY,
  6: DayOfWeek.SATURDAY,
};

export function isDateAvailable(
  date: Date | string,
  availability: Availability,
): boolean {
  const d = date instanceof Date ? date : new Date(date);

  if (availability.availableDays) {
    const dayOfWeek = NUMERIC_DAY_TO_STRING[d.getDay()];

    if (!availability.availableDays.includes(dayOfWeek)) {
      return false;
    }
  }

  if (availability.availableDates && availability.availableDates.length > 0) {
    const isInAvailableRange = availability.availableDates.some((range) =>
      isDateInRange(d, range),
    );
    if (!isInAvailableRange) {
      return false;
    }
  }

  if (
    availability.unavailableDates &&
    availability.unavailableDates.length > 0
  ) {
    const isInUnavailableRange = availability.unavailableDates.some((range) =>
      isDateInRange(d, range),
    );
    if (isInUnavailableRange) {
      return false;
    }
  }

  return true;
}

function isDateInRange(date: Date, range: DateRange): boolean {
  if (!range.start || !range.end) {
    return true;
  }

  const checkDate = startOfDay(date);
  const startDate = startOfDay(new Date(range.start));
  const endDate = startOfDay(new Date(range.end));

  return checkDate >= startDate && checkDate <= endDate;
}
